import React, { Component } from "react";
import { NavbarBrand } from "reactstrap";

import "bootstrap/dist/css/bootstrap.css";

import aepLogo from "../../assets/AEP_Primary_RGB_RG.png";
import {getUserEnvironment} from "../../api";

class AEPNavbarBrand extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userEnvironment: ""
        }
    }
    async componentDidMount(){
        const userEnvironment = await getUserEnvironment();
        this.setState({ userEnvironment } );
    }

  render() {
    return (
      <NavbarBrand id="navbar-brand" href="/" className="text-dark">
        <img id="navbar-brand-logo" src={aepLogo} alt="AEP Logo" />
        <span
          id="navbar-brand-name"
          className="ml-3"
          style={{ fontSize: "1rem" }}
        >
            Transmission Commissioning Checklist - {this.state.userEnvironment}
        </span>
      </NavbarBrand>
    );
  }
}

export default AEPNavbarBrand;
